import React, { useLayoutEffect, useRef, useCallback, useContext } from "react"
import { throttle } from "@/utils/throttle"
import { isVisible } from "@/utils/isVisible"
import { ScrollSpyContext } from "@/context/scroll-spy"

const ScrollSpy = ({ children, options = { offset: 0 }, ...props }) => {
  const { setActiveScrollSpyElement } = useContext(ScrollSpyContext)

  const scrollContainerRef = useRef()

  const updateScrollSpy = useCallback(() => {
    if (!scrollContainerRef.current) {
      return
    }
    const elementsToObserve = [...scrollContainerRef.current.children].filter(
      element => {
        const hasId = element.id.length > 0

        if (!options?.limitToQuerySelector) {
          return hasId
        }

        return hasId && element.matches(options.limitToQuerySelector)
      },
    )

    for (const element of elementsToObserve) {
      if (isVisible(element, options.offset)) {
        setActiveScrollSpyElement(`#${element.id}`)

        return
      }
    }
  }, [])

  useLayoutEffect(() => {
    window.addEventListener("scroll", throttle(updateScrollSpy, 50))

    return () =>
      window.removeEventListener("scroll", throttle(updateScrollSpy, 50))
  }, [])

  return (
    <div ref={scrollContainerRef} {...props}>
      {children}
    </div>
  )
}

export default ScrollSpy
